import React from 'react';
import { Dropdown } from '@/components/Dropdown';

export const TimezoneDropdownComponent = ({
  timezoneOptions,
  selectedTimezone,
  onChange,
  isLoading,
  label,
  placeholder,
  selectStyles,
}) => {
  const value =
    timezoneOptions.find((t) => t.value === selectedTimezone) ||
    (selectedTimezone
      ? { value: selectedTimezone, label: selectedTimezone }
      : null);

  return (
    <Dropdown
      label={label}
      placeholder={placeholder}
      options={timezoneOptions}
      value={value}
      onChange={(option) => onChange(option.value)}
      isLoading={isLoading}
      selectStyles={selectStyles}
    />
  );
};

TimezoneDropdownComponent.displayName = 'TimezoneDropdown';
